import { render } from "./FouitaWidgets.vue?vue&type=template&id=6057ae35"
import script from "./FouitaWidgets.vue?vue&type=script&lang=js"
export * from "./FouitaWidgets.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__